import type { VisibilityState } from "@tanstack/react-table";
import { useMemo } from "react";
import type { OAuthProviderItem } from "@/app/oauth/types";
import { DataTable } from "@/components/custom/table/data-table";
import { DataTableContent } from "@/components/custom/table/data-table-content";
import { DataTablePagination } from "@/components/custom/table/data-table-pagination";
import { createOAuthColumns } from "./columns";

type OAuthTableProps = {
  items: OAuthProviderItem[];
  stickyColumnBg?: "card" | "background";
  overriddenProviders?: Set<string>;
  overridingProviders?: Set<string>;
  columnVisibility?: VisibilityState;
  onColumnVisibilityChange?: (
    updater: VisibilityState | ((old: VisibilityState) => VisibilityState)
  ) => void;
};

export const OAuthTable = ({
  items,
  stickyColumnBg = "background",
  overriddenProviders,
  overridingProviders,
  columnVisibility,
  onColumnVisibilityChange,
}: OAuthTableProps) => {
  const columns = useMemo(
    () => createOAuthColumns(overriddenProviders, overridingProviders),
    [overriddenProviders, overridingProviders]
  );

  return (
    <DataTable
      className="space-y-4"
      columns={columns}
      columnVisibility={columnVisibility}
      data={items}
      defaultPageSize={20}
      onColumnVisibilityChange={onColumnVisibilityChange}
    >
      <DataTableContent stickyColumnBg={stickyColumnBg} />
      <DataTablePagination />
    </DataTable>
  );
};
